import React from "react";
import { Link, Switch } from "react-router-dom";

import {
    MainContainer,
    MainTitle,
    TitleContainer,
    ColumnContainer,
    Column,
    Tabs,
} from "@beacharound/beacharound-ui";

import SubRoute from '../../components/Routes/SubRoute';

export default function Places({ match, routes, location }) {
    
    const tabs = [{
        text: "Spiagge",
        component: Link,
        to: `${match.url}/beaches/private`,
    },{
        text: "Spiagge libere",
        component: Link,
        to: `${match.url}/beaches/public`,
    },{
        text: "Hotel",
        component: Link,
        to: `${match.url}/hotels`,
    },{
        text: "Punti di Interesse",
        component: Link,
        to: `${match.url}/pointsOfInterest`,
    },{
        text: "Comuni",
        component: Link,
        to: `${match.url}/cities`,
    },{
        text: "Province",
        component: Link,
        to: `${match.url}/districts`,
    },{
        text: "Regioni",
        component: Link,
        to: `${match.url}/regions`,
    },{
        text: "Mappa",
        component: Link,
        to: `${match.url}/maps`,
    },{
        text: "Ricerche",
        component: Link,
        to: `${match.url}/searchTerms`,
    },{
        text: "Immagini",
        component: Link,
        to: `${match.url}/images`,
    }]

    const tabsArray = tabs && tabs.map((t) => t.to)

    return (
        <React.Fragment>
            <MainContainer large>
                <TitleContainer>
                    <MainTitle text="Luoghi" />
                </TitleContainer>

                <ColumnContainer noMargin>
                    <Column>
                        <Tabs list={tabs} activeIndex={tabsArray.indexOf(location.pathname)}/>
                    </Column>
                </ColumnContainer>

                <ColumnContainer>
                    <Column>
                        <Switch>
                            {routes?.map((page, index) => {
                                return <SubRoute key={index} {...page} />;
                            })}
                        </Switch>
                    </Column>
                </ColumnContainer>
            </MainContainer>
        </React.Fragment>
    );
}
